import { useEffect } from 'react';
import { useNewBookingStore } from '../../../../domain/booking/stores/useNewBookingsStore';

export function useResetBookingOnUnmount() {
	const newBookingStore = useNewBookingStore();

	useEffect(
		() => () => {
			newBookingStore.reset();
		},
		[],
	);
}
